export enum processButtonStateTypes {
  normal = 0,
  processing = 1,
  processed = 2,
  succeeded = 3,
  failed = 4,
}
